import {AddToCartModalService} from "./addToCartModalService";

export class AddToCartModalUIService
{
    private addToCartModalService: AddToCartModalService;

    constructor()
    {
        this.addToCartModalService = new AddToCartModalService();
        this.addToCartModalService.refreshComponentTemplate();
    }

    public initialize()
    {
        this.addToCartModalService.refreshComponentTemplate();
    }
}
